/**
 * Operacions sobre el carrito
 * Nota: necessita que hi hagi un element '.component-header-cart' que tingui
 * els següents atributs definits:
 * - data-ajax-cart-add-article-url
 * - data-ajax-cart-set-article-quantity-url
 * - data-ajax-cart-empty-cart-url
 */

/* Imports */
import axios from 'axios';
import globalEventsService from '../services/global-events.service';

/* Assumed jQuery */
const $ = jQuery;

/* Data attributes */
let ajaxCartAddArticleUrl;
let ajaxCartSetArticleQuantityUrl;
let ajaxCartEmptyCartUrl;
let ajaxCartApplyPromoCodeUrl;

/* State */
let active = false;
let loading = false;

/* Init itself */
init();

/*----------------------------------------------------------------------
 * Exported functions
 */

/**
 * @return void
 */
function init() {
    /* Search for cart component to get some URLs */
    const jqComponent = $('.component-header-cart');
    if (jqComponent.length == 0) return;

    /* We have component, activate */
    active = true;

    /* Get data attributes */
    ajaxCartAddArticleUrl = jqComponent.data('ajax-cart-add-article-url')
    ajaxCartSetArticleQuantityUrl = jqComponent.data('ajax-cart-set-article-quantity-url')
    ajaxCartEmptyCartUrl = jqComponent.data('ajax-cart-empty-cart-url')
    ajaxCartApplyPromoCodeUrl = jqComponent.data('ajax-cart-apply-promocode')
}

/**
 * @return void
 */
function open() {
    jqComponent.addClass('open');
}

/**
 * @return void
 */
function close() {
    jqComponent.removeClass('open');
}

/**
 * @param int|string idProducte
 * @param array<int|string> idsProducteColor
 * @return Promise<bool|string> true on success, otherwise string with error
 */
function addArticle(idProducte, idsProducteColor, quantitat, personalizacion) {
    return axios.post(ajaxCartAddArticleUrl, {
        id_producte: idProducte.toString(),
        ids_producte_color: idsProducteColor.join(','),
        quantitat: quantitat !== undefined ? quantitat : 1,
        personalizacion: personalizacion !== undefined ? personalizacion : '',
    })
        .then(response => {
            globalEventsService.dispatchEvent(
                globalEventsService.EVENT_CART_UPDATE,
                {add_article: true});
            globalEventsService.dispatchEvent(
                globalEventsService.EVENT_CART_ADD_ARTICLE,
                response.data.producteEventData);
            return true;
        });
}

/**
 * @param int|string idProducte
 * @param array<int|string> idsProducteColor
 * @param int quantity
 * @return Promise<bool|string> true on success, otherwise string with error
 */
function setArticleQuantity(idProducte, idsProducteColor, quantity) {
    axios.post(ajaxCartSetArticleQuantityUrl, {
        id_producte: idProducte,
        ids_producte_color: idsProducteColor,
        quantity: quantity,
    }).then((response) => {
        globalEventsService.dispatchEvent(
            globalEventsService.EVENT_CART_UPDATE);
        if (quantity == 0) {
            globalEventsService.dispatchEvent(
                globalEventsService.EVENT_CART_REMOVE_ARTICLE,
                response.data.producteEventData);
        }
        return true;
    });
}

/**
 * @param int|string idProducte
 * @param array<int|string> idsProducteColor
 * @return Promise<bool|string> true on success, otherwise string with error
 */
function removeArticle(articleIndex) {
    return axios.post(ajaxCartRemoveArticleUrl, {
        article_index: articleIndex,
    })
        .then(response => {
            globalEventsService.dispatchEvent(globalEventsService.EVENT_CART_UPDATE);
            globalEventsService.dispatchEvent(
                globalEventsService.EVENT_CART_REMOVE_ARTICLE,
                response.data.producteEventData);
            return true;
        })
}

/**
 * @return Promise<bool|string> true on success, error message otherwise
 */
function emptyCart() {
    return axios.post(ajaxCartEmptyCartUrl)
        .then(response => {
            globalEventsService.dispatchEvent(globalEventsService.EVENT_CART_UPDATE);
            return true;
        })
        .catch(error => {
            return error.response.data;
        });
}

function applyPromoCode(promoCode) {
    axios.post(
        ajaxCartApplyPromoCodeUrl,
        {promoCode: promoCode}
    ).then((response) => {
        globalEventsService.dispatchEvent(
            globalEventsService.EVENT_CART_UPDATE);
        return true;
    }).catch(error => {
        return error.response.data;
    });
}

/*----------------------------------------------------------------------
 * Private functions
 */

/*----------------------------------------------------------------------
 * Default export object
 */
export default {
    init,
    addArticle,
    setArticleQuantity,
    emptyCart,
    applyPromoCode
};
